import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import useAxios from 'hooks/useAxios';

const NDCList = ({ selectedNDC, onSelect,selectedRow,requiredflag,add}) => {
  console.log(selectedNDC,"selectedndc")
  const API = useAxios();
  const [ndcName, setNDCName] = useState(null);
  const [ndcOpt, setNDCOpt] = useState([]);
  const [ndcLoading, setNdCLoading] = useState(false);

  useEffect(() => {

    if (ndcOpt.length && !selectedNDC) {
      setNDCOpt([]);
    }
  }, [selectedNDC]);

  const handleChangeProvider = async (value) => {
    setNDCName(value);
    if (value.length >= 3) {
      setNdCLoading(true);
      try {
        const result = await API.get(`SBConfig/AutoSearch/NdcList/${value}`, {
          hasDefaultURL: true,
        });
        if (result?.data?.length > 0) {
          setNDCOpt(result.data);
          setNdCLoading(false);
          // SeterrorNDC(false)
        } else {
          setNDCOpt([]);
          setNdCLoading(false);
                    // SeterrorNDC(false)

        }
      } catch (error) {
        setNdCLoading(false);
      }
    }

  };

  const onSelectNdc = (provider) => {
    onSelect(provider);
  };

  return (
    <Select
    
    className= {requiredflag == true? "form-field-large inner-shadow-field required" : "form-field-large inner-shadow-field"}
      classNamePrefix="select"
      IndicatorSeparator
      // isClearable={selectedRow == undefined ? false : true}
      isSearchable={true}
      isLoading={ndcLoading}
       isClearable={true}
      // isDisabled={selectedRow == undefined ? false : selectedRow.mapingStatus == "UnmappedNDC"}
      placeholder={add?add:"Enter Drug Name or NDC"}
      name="color"
      options={ndcOpt}
      inputValue={ndcName}
      value={selectedNDC}
      onInputChange={handleChangeProvider}
      onChange={onSelectNdc}
      getOptionLabel={(option) => option.description}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
    />
  );
};

export default NDCList;
